/* Sélection de presse locale à la section : aucun carrousel ni minuterie.
   Le clavier et l'éditeur Shopify activent le même panneau que le toucher. */
if (!customElements.get('jaiio-press')) {
  customElements.define('jaiio-press', class extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      if (!this.tabs.length) return;
      this.onClick = (event) => this.select(this.tabFrom(event));
      this.onHover = (event) => {
        if (event.pointerType === 'mouse') this.select(this.tabFrom(event));
      };
      this.onKey = (event) => {
        const tab = this.tabFrom(event);
        if (!tab) return;
        const index = this.tabs.indexOf(tab);
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this.select(this.tabs[next]);
        this.tabs[next].focus();
      };
      this.onBlock = (event) => {
        this.select(this.tabs.find((tab) => tab.dataset.blockId === event.detail?.blockId));
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('pointerover', this.onHover);
      this.addEventListener('keydown', this.onKey);
      this.addEventListener('shopify:block:select', this.onBlock);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('pointerover', this.onHover);
      this.removeEventListener('keydown', this.onKey);
      this.removeEventListener('shopify:block:select', this.onBlock);
    }

    tabFrom(event) {
      const tab = event.target.closest('[role="tab"]');
      return this.tabs.includes(tab) ? tab : null;
    }

    select(selected) {
      if (!selected) return;
      for (const tab of this.tabs) {
        const active = tab === selected;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        const panel = this.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`);
        if (panel) panel.hidden = !active;
      }
    }
  });
}
